import React from "react";
import "./PrivacyPolicy.css";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import FlashSale from "../Flash Sale/FlashSale";

const ReturnPolicy = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1>Return Policy</h1>
        <div className="privacy-policy-content">
          <p>
            At ‘Kharutaai’, we are Committed to Serve the Best in Class &amp; we make sure that our
            Customers are completely satisfied with their Baby Shopping.
          </p>
          <p>
            Our Return Policy is designed to provide you with a straightforward &amp; hassle-free return
            process. Please Review the following details to understand our Return policy &amp; how to
            proceed with a Return Transaction.
          </p>
          <h2>1. Eligibility for Returns</h2>
          <p>
            To be eligible for a Return, please ensure the following criteria are met:
          </p>
          <ul>
            <li>The item must be returned within 10 days from the Date of Delivery of Product.</li>
            <li>The Product must be in its Original Condition, unused, & with all Tags & Packaging intact.</li>
            <li>A Receipt or Proof of purchase must be included with the returned Product.</li>
            <li>Products that are marked as Non-Returnable or Clearance Items cannot be Returned.</li>
          </ul>

          <h2>2. How to Return an Item</h2>
          <p>If you need to return an item, follow these steps:</p>
          <ul>
            <li>Contact our Customer Service Team to initiate the Return Process. You can reach us at <a href="mailto:Connect@Kharutaai.com">Connect@Kharutaai.com</a> or WhatsApp at <a href="https://wa.me/919833368284">+91 98333 68284</a>.</li>
            <li>Provide your Order Number & Reason for the Return. We will issue a Return Authorization & instructions for sending the Product back to us.</li>
            <li>Package the Product securely in its Original Packaging, including all Tags & Accessories.</li>
            <li>Ship the package to the Store Address provided in your Return Authorization.<b> Delivery Charges for the Return Process are to be solely borne at the Customer's end.</b></li>
            <li>Please ensure that you use a Trackable Shipping Service. We are not responsible for Products lost or damaged during Return Shipping.</li>
          </ul>

          <h2>3. Refund Process</h2>
          <p>
            Once we receive &amp; inspect your Returned Product, we will notify you via Email/Number
            of the Status of your Refund. The following points outline the Refund Process:
          </p>
          <ul>
            <li>If your return is approved, we will process a refund to your original method of payment. Please allow 7-10 business days for the refund to appear in your account, depending on your bank servers.</li>
            <li>If your return is rejected, we will contact you with an explanation & offer the option to have the item shipped back to you at your expense.</li>
          </ul>

          <h2>4. Exchanges</h2>
          <p>
            If you need to Exchange an Item, follow these steps:
          </p>
          <ul>
            <li>Contact our Customer Service Team to initiate the Exchange Process. You can reach us at <a href="mailto:Connect@Kharutaai.com">Connect@Kharutaai.com</a> or WhatsApp at <a href="https://wa.me/919833368284">+91 98333 68284</a>.</li>
            <li>Provide your Order Number & Reason for the Exchange. We will issue an Exchange Authorization & instructions for Exchange.</li>
            <li>Package the Product securely in its Original Packaging, including all Tags & Accessories.</li>
          </ul>


          <h2>5. Defective or Damaged Items</h2>
          <p>
            If you receive a Product that is Defective or Damaged upon arrival, please contact us
            immediately. We will provide instructions for returning the item &amp; arrange for a
            Replacement or Refund, depending on your preference &amp; Stock Availability.
          </p>
          <h2>6. Non-Returnable Items</h2>
          <p>
            Certain Products are Non-Returnable, including but not limited to:
          </p>
          <ul>
            <li>Personalized or Custom-made Products.</li>
            <li>Gift cards.</li>
            <li>Items marked as final sale or Clearance.</li>
          </ul>

          <h2>7. Contact Us</h2>
          <p>
            If you have any questions or concerns about our Return Policy, please do reach out to
            us:
            <br /><br />
            Email: Connect@Kharutaai.com
            <br />
            Phone: +919833368284
            <br />
            Address: Shop no. 05, Krishna Niwas, opp to TBZ Jewellers, near Chitale
            Express,BCabin Road, Thane West.
            <br /><br />
            We value your satisfaction &amp; are here to assist you with any issues regarding your
            Purchase. Thank you for Baby Shopping with Kharutaai (Formerly known as
            Prathamesh Balache Kapade).
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ReturnPolicy;
